export const SKYPE = 'skype:live:igor.korobka?chat';
export const TELEGRAM = 'tg://resolve?domain=@topsrc';
export const EMAIL = 'mailto:sales@topsrc.com';